import { render, staticRenderFns } from "./RaporAiSihirbazi.vue?vue&type=template&id=5f04ab63&scoped=true"
import script from "./RaporAiSihirbazi.vue?vue&type=script&lang=ts"
export * from "./RaporAiSihirbazi.vue?vue&type=script&lang=ts"
import style0 from "./RaporAiSihirbazi.vue?vue&type=style&index=0&id=5f04ab63&prod&scoped=true&lang=css"
import style1 from "./RaporAiSihirbazi.vue?vue&type=style&index=1&id=5f04ab63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f04ab63",
  null
  
)

export default component.exports